// src/theme/typography.ts
export const TEXT_STYLES = {
  h1: 'text-3xl font-bold tracking-tight text-[#465357]',
  h2: 'text-2xl font-semibold tracking-tight text-[#465357]',
  h3: 'text-xl font-semibold text-[#465357]',
  h4: 'text-lg font-semibold text-[#465357]',
  subtitle: 'text-lg font-medium text-[#465357]', // добавлен subtitle
  body: 'text-base text-[#465357]',
  small: 'text-sm text-[#465357]',
  tiny: 'text-xs text-[#465357]'
} as const;